import React, { useState } from 'react';
import { Alert, Button, Modal, Steps, Tooltip, Typography, Checkbox, Upload, Input } from 'antd';
import TestConnectionContent from './TestConnectionContent';
import classes from './GCPInfoModal.module.css';
const { Paragraph } = Typography;
import { connect } from 'dva';
import { isEmpty } from 'lodash';
import { decryptAES, formatRoleNames } from '@/utils/utils';
import { InboxOutlined } from '@ant-design/icons';
const { Dragger } = Upload;
import CryptoJS from 'crypto-js';
import GCPSvgIcon from '@/../public/gcp-logo.svg';
import { getSignedUrl } from '@/utils/utils';

const UpgradeInfoSteps = ({
  setChecked,
  cloudAccountData,
  handleBeforeUpload,
  handleFileChange,
  handleInputChange,
  roleNames,
  dispatch,
  props,
}) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const serviceAccount = JSON.parse(decryptAES(cloudAccountData.userkeys));
  const { gcpSignedURL, loadingSignedUrl } = props;

  const signedUrlCommand = `wget "${gcpSignedURL}" -O advanced-onboarding.zip`;

  return (
    <div>
      <Alert
        description="Ensure that your IAM user has at least the Editor role in order to perform the onboarding steps smoothly."
        type="info"
        showIcon
        style={{ margin: '30px 0' }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h5 className={classes.stepsHeadings}>
          <span>Update Service Account</span>
        </h5>
      </div>
      {/* !!  info steps by shell */}
      <div className={(classes.flexColumn, classes.cardMain)}>
        <div style={{ display: 'flex', gap: '4rem', justifyContent: 'space-between' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',

              marginBottom: '10px',
            }}
          >
            <Alert
              description={
                <>
                  We recommend deleting the previously created service account/(s) ("
                  <b>
                    <i>cloudnosys-sa-**** </i>
                  </b>
                  ") and the respective downloaded key (“
                  <b>
                    <i>cloudnosys-sa-****-key.json</i>
                  </b>
                  ”) to follow security best practices and avoid clutter in your IAM.
                </>
              }
              type="warning"
              showIcon
              style={{ marginBottom: '30px' }}
            />

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>1</div>
                </div>
              </div>
              <div style={{ display: 'inline', marginTop: '-5px', marginBottom: '12px' }}>
                <p>
                  <b>Access GCP Console and Open Cloud Shell:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    <p style={{ display: 'inline', margin: '0' }}>
                      Log in to the Google Cloud Console by clicking
                    </p>
                    <a
                      href="https://console.cloud.google.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    >
                      &nbsp;<u>here</u>&nbsp;
                    </a>
                    <p style={{ display: 'inline', margin: '0' }}>
                      and select your connected project named “
                      <b>
                        <i>{serviceAccount.credentials.project_id}</i>
                      </b>
                      ”.
                    </p>
                  </li>

                  <li>
                    Click the “Activate Cloud Shell” button in the top-right corner to open the
                    terminal.
                  </li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>2</div>
                </div>
              </div>
              <div id="myForm">
                <p>
                  <b>Download the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    In the Cloud Shell, run the following command to download the onboarding script:
                  </li>
                </ul>
                <div
                  style={{
                    display: 'flex',
                    gap: '1.7rem',
                  }}
                >
                  {gcpSignedURL.length ? (
                    <Paragraph
                      copyable={{ text: signedUrlCommand }}
                      className={classes.paragraphStyle}
                    >
                      {signedUrlCommand}
                    </Paragraph>
                  ) : (
                    <Paragraph className={classes.paragraphStyle}>
                      Click on the Generate Signed Url Button
                    </Paragraph>
                  )}
                  <Tooltip title="The Signed URL will be valid for 15 min Only">
                    <Button
                      style={{ backgroundColor: 'transparent', color: '#252525A6' }}
                      onClick={() => getSignedUrl('advanced', 'gcp', dispatch, setIsDisabled)}
                      size="large"
                      disabled={isDisabled}
                      loading={loadingSignedUrl}
                    >
                      <img
                        src={GCPSvgIcon}
                        alt="Aws logo here"
                        style={{ marginRight: '10px', height: '1rem', width: '2rem' }}
                      />
                      Generate Signed URL
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>3</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Unzip and Run the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Run the following command to unzip the file, make the script executable, and
                    then execute the script:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  unzip advanced-onboarding.zip && chmod +x advanced-onboarding.sh &&
                  ./advanced-onboarding.sh
                </Paragraph>
                <p>
                  <i>
                    <b>Note:</b>&nbsp;This will create a service account with least privileged
                    access, custom IAM roles for best practices, tags for resource management and
                    tracking, and the service account key required to complete onboarding for
                    Advanced protection level
                  </i>
                </p>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>4</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Download the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    In the Cloud Shell, run the following command to verify the key file was
                    created:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  ls ~/cloudnosys-sa-*.json
                </Paragraph>
                <ul className={classes.listStyle}>
                  <li>
                    Click the three-dotted “More” menu in the top-right corner of Cloud Shell and
                    select “<b>Download File</b>”.
                  </li>
                  <li>
                    Locate and download the <b>cloudnosys-sa-****key.json</b> file to your local
                    machine.
                  </li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>5</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Custom Roles:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>Provide the custom roles names in the fields below:</li>
                </ul>
                <div
                  style={{
                    display: 'flex',
                    gap: '1.7rem',
                    marginBottom: '1rem',
                  }}
                >
                  <Input
                    placeholder="Cloudnosys Create Role ****"
                    value={roleNames.cloudnosysCreateRole}
                    onChange={e => handleInputChange('cloudnosysCreateRole', e)}
                  />
                  <Input
                    placeholder="Cloudnosys Delete Role ****"
                    value={roleNames.cloudnosysDeleteRole}
                    onChange={e => handleInputChange('cloudnosysDeleteRole', e)}
                  />
                </div>
              </div>
            </div>
            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>6</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Upload the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Drag and drop, or browse to upload the downloaded JSON key file into the box
                    below.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Dragger
          name="file"
          multiple={false}
          beforeUpload={handleBeforeUpload}
          onChange={handleFileChange}
          // showUploadList={false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Now browse the key or drag and drop in the box below</p>
        </Dragger>
      </div>

      <Checkbox
        onChange={e => setChecked(e.target.checked)}
        style={
          {
            // color: '#252525A6',
          }
        }
      >
        I acknowledge that I have read and understood the recommendation above and I also confirm
        that the service account has been created successfully.
      </Checkbox>
    </div>
  );
};

const GCPUpgradeInfoModal = props => {
  const {
    cloudAccountData,
    setUpgradeInfoModal,
    upgradeInfoModal,
    setModeCheckbox,
    dispatch,
    testConnectionTypes,
  } = props;
  const [current, setCurrent] = useState(0);
  const [checked, setChecked] = useState(false);
  const [updatingAccount, setUpdatingAccount] = useState(false);
  const [serviceAccount, setServiceAccount] = useState('');
  const [roleNames, setRoleNames] = useState({
    cloudnosysCreateRole: '',
    cloudnosysDeleteRole: '',
  });

  const handleInputChange = (field, event) => {
    const value = event.target.value;
    setRoleNames(prevRoleNames => ({
      ...prevRoleNames,
      [field]: value,
    }));
  };
  const handleUpgradeAccount = async () => {
    await dispatch({
      type: 'cloudAccounts/updateCloudAccountMode',
      payload: {
        cloudAccountId: cloudAccountData.id,
        protectionLevel: 'advanced',
      },
    });

    const payload = {
      ...cloudAccountData,
      protectionLevel: 'advanced',
    };

    runScan(payload);
    setUpgradeInfoModal(true);
    Modal.destroyAll();
  };

  const runScan = accountData => {
    const { dispatch } = props;

    // Get currently scanning cloud accounts Ids
    let currentlyScanningCloudAccountsIds = getCurrentlyScanningCloudAccountsIds({
      shouldFilterWithStartScanStatus: true,
    });

    // Reset scan progress if currently no cloud account is scanning
    if (currentlyScanningCloudAccountsIds.length === 0) {
      dispatch({
        type: 'cloudAccount/clearScanProgress',
      });
    }

    dispatch({
      type: 'scan/runScan',
      payload: {
        cloudAccounts: [accountData],
        orgId: accountData.orgId,
        currentlyScanningCloudAccountsIds,
      },
    });

    dispatch({
      type: 'scopeReport/current',
    });
  };
  const getCurrentlyScanningCloudAccountsIds = ({ shouldFilterWithStartScanStatus = true }) => {
    const { allCloudAccountsList } = props;

    // Get currently scanning cloud accounts Ids
    const currentlyScanningCloudAccountsIds = allCloudAccountsList
      .filter(
        cloudAccount =>
          cloudAccount.status === 'running-scan' ||
          (shouldFilterWithStartScanStatus && cloudAccount.status === 'start-scan')
      )
      .map(cloudAccount => cloudAccount.id);

    return currentlyScanningCloudAccountsIds;
  };

  const handleFileChange = info => {
    const { file, fileList } = info;

    if (file.status === 'done') {
      message.success(`${file.name} file uploaded successfully.`);
      // Handle file upload success, possibly inform parent component
    } else if (file.status === 'error') {
      message.error(`${file.name} file upload failed.`);
      // Handle file upload failure, possibly inform parent component
    }

    // Check if a file was removed from the list
    if (
      fileList.length === 0 ||
      fileList.find(f => f.uid === file.uid && file.status === 'removed')
    ) {
      // File has been removed, perform necessary state update or inform parent
      setServiceAccount(''); // Example: reset the related form value
    }
  };

  const handleBeforeUpload = file => {
    const reader = new FileReader();
    reader.onload = e => {
      // Here you can access the file content
      const content = e.target.result;
      try {
        setServiceAccount(content);
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    };
    reader.readAsText(file);

    return false;
  };

  const updateAccountAndTestConnection = async () => {
    setUpdatingAccount(true);
    const { dispatch } = props;

    let credentials = JSON.parse(serviceAccount);
    let projectId = credentials.project_id;

    let googlKey = { projectId, credentials };
    let userkeys = CryptoJS.AES.encrypt(JSON.stringify(googlKey), REACT_APP_SECRET).toString();

    const payloadData = {
      cloudXrayConfig: {
        ...cloudAccountData.cloudXrayConfig,
        // scanRunningInstances,
        updatedAt: new Date(),
      },
      userkeys,
      roleNames: formatRoleNames(roleNames),
    };

    await dispatch({
      type: 'cloudAccount/save',
      payload: {
        roleNames: formatRoleNames(roleNames),
      },
    });
    await dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'edit',
          provider: cloudAccountData.provider,
          orgId: cloudAccountData.orgId,
          id: cloudAccountData.id,
        },
        data: payloadData,
      },
    });

    setUpdatingAccount(false);
  };

  const steps = [
    {
      title: 'Update Service Account',
      content: (
        <>
          <UpgradeInfoSteps
            setChecked={setChecked}
            cloudAccountData={cloudAccountData}
            props={props}
            dispatch={dispatch}
            handleFileChange={handleFileChange}
            handleBeforeUpload={handleBeforeUpload}
            handleInputChange={handleInputChange}
            roleNames={roleNames}
          />
        </>
      ),
    },
    {
      title: 'Testing',
      content: (
        <TestConnectionContent
          isEditCloudAccount={true}
          cloudAccountData={cloudAccountData}
          byPassAndTestAll={true}
          connectionProtectionType="advanced"
          roleNames={roleNames}
        />
      ),
    },
  ];

  const items = steps.map(item => ({
    key: item.title,
    title: item.title,
  }));

  const next = () => {
    if (!roleNames.cloudnosysCreateRole || !roleNames.cloudnosysDeleteRole) {
      return;
    }

    setCurrent(current + 1);
    updateAccountAndTestConnection();
  };

  const prev = () => {
    setCurrent(current - 1);
    setChecked(false);
  };

  const handleCancel = () => {
    // setModeCheckbox(cloudAccountData.protectionLevel);
    setUpgradeInfoModal(false);
    // onUnmount();
  };

  const isAllConnectionConnected = () =>
    !isEmpty(testConnectionTypes) &&
    Object.keys(testConnectionTypes).every(key => testConnectionTypes[key].status === 200);

  const buttonsActions = [
    {
      firstBtn: 'Cancel',
      secondBtn: 'Test Connection',
      onClickFirstBtn: handleCancel,
      onClickSecondBtn: next,
      // Disable the next button if any of the required fields are empty or checkbox not checked
      disabledSecondBtn:
        !checked || !roleNames.cloudnosysCreateRole || !roleNames.cloudnosysDeleteRole,
      disabledSecondBtnTooltipText: !checked
        ? 'Please acknowledge the checkbox and fill in both Create Role and Delete Role fields'
        : 'Test Connection',
    },
    {
      firstBtn: 'Previous',
      secondBtn: 'Finish and Run Scan',
      onClickFirstBtn: prev,
      onClickSecondBtn: handleUpgradeAccount,
      disabledSecondBtn: !isAllConnectionConnected(),
      disabledSecondBtnTooltipText: 'Please test all connections first',
    },
  ];

  return (
    <Modal
      visible={upgradeInfoModal}
      onOk={false}
      onCancel={() => {
        setModeCheckbox(cloudAccountData.protectionLevel);
        setUpgradeInfoModal(false);
      }}
      closable={false}
      bodyStyle={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}
      width={1000}
      destroyOnClose
      footer={[
        <Button key="back" onClick={buttonsActions[current].onClickFirstBtn}>
          {buttonsActions[current].firstBtn}
        </Button>,
        <Tooltip
          style={{
            marginLeft: '14px',
          }}
          placement="bottom"
          title={buttonsActions[current].disabledSecondBtnTooltipText}
        >
          <Button
            key="submit"
            type="primary"
            onClick={buttonsActions[current].onClickSecondBtn}
            disabled={buttonsActions[current].disabledSecondBtn}
            style={{
              marginLeft: '14px',
            }}
          >
            {buttonsActions[current].secondBtn}
          </Button>
        </Tooltip>,
      ]}
    >
      <Steps size="small" current={current} items={items} />
      {steps[current].content}
    </Modal>
  );
};
export default connect(({ cloudAccount }) => ({
  testConnectionTypes: cloudAccount.testConnectionTypes,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
  gcpSignedURL: cloudAccount.gcpSignedURL,
  loadingSignedUrl: cloudAccount.loadingSignedUrl,
}))(GCPUpgradeInfoModal);
